module.exports = __webpack_public_path__ + "img/portrait1Side.25ac4f54.jpg";